module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sign-up-basics"
  }, [_c('header-bar'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "long-form"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "shift-3 col-3"
  }, [_c('label', [_vm._v("First name:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.firstname),
      expression: "firstname",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "John",
      "required": ""
    },
    domProps: {
      "value": (_vm.firstname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.firstname = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('label', [_vm._v("Last name:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.surname),
      expression: "surname",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "Smith",
      "required": ""
    },
    domProps: {
      "value": (_vm.surname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.surname = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "shift-3 col-3"
  }, [_c('label', [_vm._v("Where do you work?")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.organisation),
      expression: "organisation",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "Example PLC",
      "required": ""
    },
    domProps: {
      "value": (_vm.organisation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.organisation = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('label', [_vm._v("Organisation website:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.website),
      expression: "website",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "url",
      "placeholder": "example.com",
      "required": ""
    },
    domProps: {
      "value": (_vm.website)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.website = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "shift-3 col-3"
  }, [_c('label', [_vm._v("Where are you currently based?")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.location),
      expression: "location",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "London"
    },
    domProps: {
      "value": (_vm.location)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.location = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('label', [_vm._v("What's your job title?")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.jobtitle),
      expression: "jobtitle",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "Operations Manager",
      "required": ""
    },
    domProps: {
      "value": (_vm.jobtitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.jobtitle = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])])])]), _vm._v(" "), _c('section', {
    staticClass: "sign-up-navigation"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('a', {
    staticClass: "link-back",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.cancel($event)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-big bg-four active",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.save($event)
      }
    }
  }, [_vm._v("Save")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "instructions"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('h2', [_vm._v("Tell us a bit more about you, your work and areas of interest.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2aef9601"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/edit-profile/UserMeta.vue
// module id = 698
// module chunks = 1